import { toaster } from 'uikit/Toaster'
import { useQuery } from '@tanstack/react-query'
import { api } from 'api'

export const useFetchPayment = (id: string) => {
  const response = useQuery({
    queryKey: ['paymentCard', id],
    queryFn: () => api.payments.fetchPaymentsItem(id),
    enabled: !!id,
  })

  if (response.isError) {
    toaster.create({
      title: 'Не удалось загрузить данные платежа',
      description: response.error?.message,
      type: 'error',
      duration: 9000,
      isClosable: true,
    })
  }

  return {
    data: response.data,
    isFetching: response.isFetching,
    isLoading: response.isLoading,
    error: response.error,
  }
}
